<template>
  <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span class="text-center">Daily Update</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-subtitle class="px-4 pt-4">
        <h2>Previous Synopsis</h2>
        <h5>{{ follow_up_date.value.value }}</h5>
        <p>{{ show_details.value.value }}</p>
      </v-card-subtitle>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="DailyUpdateSetup">
          <v-row>
            <v-col cols="12">
              <v-textarea
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="synopsis_details.value.value"
                :error-messages="synopsis_details.errorMessage.value"
                clearable
              >
                <template #label>
                  Synopsis Details <span class="text-red-accent-4">*</span>
                </template>
              </v-textarea>

              <v-date-input
                prepend-icon=""
                prepend-inner-icon="mdi-calendar"
                label="Next Follow up date"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="follow_up_date.value.value"
                :error-messages="follow_up_date.errorMessage.value"
                autocomplete="off"
                clearable
              >
                <template #label>
                  Follow up date
                  <span class="text-red-accent-4">*</span>
                </template>
              </v-date-input>

              <v-date-input
                prepend-icon=""
                prepend-inner-icon="mdi-calendar"
                label="Next Follow up date"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="next_follow_up_date.value.value"
                :error-messages="next_follow_up_date.errorMessage.value"
                autocomplete="off"
                clearable
              >
                <template #label>
                  Next Follow up date
                  <span class="text-red-accent-4">*</span>
                </template>
              </v-date-input>
              
              <v-autocomplete
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                v-model="lead_status_id.value.value"
                :items="getSalesLeadStatus"
                :item-title="(item) => `${item.name}`"
                item-value="id"
                :error-messages="lead_status_id.errorMessage.value"
                autocomplete="off"
                clearable
              >
                <template #label>
                  Lead Status
                  <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>

              <v-checkbox
                label="Active"
                v-model="status.value.value"
                :error-messages="status.errorMessage.value"
                density="compact"
                variant="outlined"
                hide-details
                single-line
                color="primary"
                value="1"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
                >Close</v-btn
              >
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                {{ isEntryMode ? "Save" : "Update" }}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "DailyUpdateSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        status: "1",
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: "",
      loading: false,
      isEntryMode: true,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        console.log(newData.id);
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.status.setValue(String(newData.status) || "1", false);

        this.lead_id.setValue(newData.id || "", false);
        this.lead_status_id.setValue(newData.lead_status_id || "", false);
        this.follow_up_date.setValue(new Date());
        // this.next_follow_up_date.setValue(
        //   newData.next_follow_up_date || "",
        //   false
        // );
        this.show_details.setValue(newData.synopsis_details || "", false);
      },
    },
  },
  created() {
    if (this.$store.getters.getSalesLeadInterest.length === 0) {
      this.$store.dispatch("getSalesLeadInterest");
    }
    if (this.$store.getters.getSalesLeadStatus.length === 0) {
      this.$store.dispatch("getSalesLeadStatus");
    }
    if (this.$store.getters.getSalesLeadAction.length === 0) {
      this.$store.dispatch("getSalesLeadAction");
    }
  },
  computed: {
    getSalesLeadInterest() {
      return this.$store.getters.getSalesLeadInterest;
    },
    getSalesLeadStatus() {
      return this.$store.getters.getSalesLeadStatus;
    },
    getSalesLeadAction() {
      return this.$store.getters.getSalesLeadAction;
    },
  },
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        lead_status_id: yup.string().nullable().label("Lead Status ID"),
        next_follow_up_date: yup
          .string()
          .nullable()
          .label("Next Follow Up Date"),
        synopsis_details: yup.string().nullable().label("Synopsis Details"),
        status: yup.string().required().label("Status"),
      }),
    });
    const lead_id = useField("lead_id");
    const show_details = useField("show_details");
    const synopsis_details = useField("synopsis_details");
    const lead_status_id = useField("lead_status_id");
    const next_follow_up_date = useField("next_follow_up_date");
    const follow_up_date = useField("follow_up_date");
    const status = useField("status");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const submit = handleSubmit((values) => {
      values.follow_up_date = follow_up_date.value.value
        ? formattedDate(follow_up_date.value.value)
        : null;
      values.next_follow_up_date = next_follow_up_date.value.value
        ? formattedDate(next_follow_up_date.value.value)
        : null;

      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key] || "");
      });

      // ধরো lead_id তুমি props থেকে নিচ্ছো বা অন্য কোথাও থেকে আসছে
      const leadId = lead_id.value.value;
      console.log(leadId);

      store
        .dispatch("saveUpdateActivityLogs", { lead_id: leadId, formData })
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          emit("update-success");
          toast.success(response.data.message);
          loading.value = true;
          // Refresh the lead details after updating
          Promise.all([
            store.dispatch("getSalesLeads"),
            store.dispatch("getSalesLeadsById", leadId),
          ]).finally(() => {
            loading.value = false;
          });
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Something went wrong");
        });
    });
    return {
      submit,
      lead_id,
      show_details,
      lead_status_id,
      next_follow_up_date,
      follow_up_date,
      synopsis_details,
      errorMessages,
      resetForm,
      status,
      loading,
    };
  },
  mounted() {},
};
</script>
